import request, { BASE_URL } from './request'

export interface Customer {
  id: string
  telegram_id: string
  referral_code: string
  username: string
  points: number
  first_name: string
  last_name: string
  created_at: string
  updated_at: string
  photo_url: string
}

export const getCustomer = async (telegramId: string): Promise<Customer> =>
  request({
    method: 'GET',
    url: `${BASE_URL}/customers/get_customer/${telegramId}`,
  })
